// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import {
  pollUnlessLive,
  useIsEMRLive,
} from "src/services/emr/live/emrLiveStatus";

// Types and API
import { getEMRHubs } from "../../api";
import { EMRHubType } from "../../types";
import { HUB_PROBLEMS_REFRESH_MS } from "../emr-problems/useEMRHubProblems";

export const useEMRHubs = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();
  const isLive = useIsEMRLive();

  return useQuery<Array<EMRHubType>>({
    queryKey: ["emr-hubs", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      return getEMRHubs(token, clinicId);
    },
    refetchInterval: pollUnlessLive(isLive, HUB_PROBLEMS_REFRESH_MS),
    refetchOnWindowFocus: true,
    staleTime: 0, // do not cache so data is always fresh on the dashboard
  });
};
